import PropTypes from 'prop-types';
import { pure } from 'recompose';

import ruleMatchChoices from 'app/beta-editor/ruleMatchChoices';

const ruleFields = {
  key: {
    key: 'key',
    type: 'unicode',
    required: true,
    choices: [], // filled dynamically!,
    isAccordion: true,
    noSpecialValues: true,
    prefill: 'gives',
  },
  match: {
    isFilterCriteria: true,
    key: 'match',
    type: 'unicode',
    choices: Object.keys(ruleMatchChoices).map(matchValue => ({
      label: ruleMatchChoices[matchValue],
      value: matchValue,
    })),
    required: true,
    noSpecialValues: true,
  },
  value: {
    isFilterCriteria: true,
    key: 'value',
    type: 'unicode',
    required: true,
  },
};

const FilterRuleEditorField = props => {
  return props.config.createFieldElement({
    field: {
      ...ruleFields[props.type],
      // TODO: Correct way to do this?
      meta: props.field.meta,
      parent: props.field.parent,
      value: props.value || '',
    },
    onAction: props.onAction,
    onChange: props.onChange,
  });
};

FilterRuleEditorField.propTypes = {
  type: PropTypes.oneOf(Object.keys(ruleFields)).isRequired,
  value: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

const enhanceFilterRuleEditorField = pure;

export default enhanceFilterRuleEditorField(FilterRuleEditorField);
